import AgendaCV from "./controladorVista/agendaCV";
import { CalendarStyles } from "./vista/estilosAgenda";


export const Agenda = () => {
    return (
        <>
            <CalendarStyles />
            <AgendaCV />
        </>
    );
}

